import { create } from 'zustand';

import { SettingsDto } from '~modules/settings/model';

type SettingsStoreState = {
	settings: { [key: string]: SettingsDto };
	setSettings: (val: { [key: string]: SettingsDto }) => void;
	changeValue: (key: string, value: string) => void;
};

export const settingsStore = create<SettingsStoreState>(set => ({
	settings: {},
	setSettings: (val: { [key: string]: SettingsDto }) => set({ settings: val }),
	changeValue: (key, value) =>
		set(state => {
			const settings = { ...state.settings };
			settings[key] = { ...settings[key], value };
			return { settings };
		}),
}));
